import { createFragmentContainer, graphql } from 'react-relay';
import PipelinesComponent from './PipelinesComponent';

export default createFragmentContainer(
  PipelinesComponent,
  {
    viewer: graphql`
      fragment PipelinesContainer_viewer on User {
        id
        s_time_zone
        pipelines(first: 99999) @connection(key: "PipelinesContainer_pipelines") {
          edges {
            node {
              id
              title
              plists(first: 99999) @connection(key: "PipelinesContainer_plists") {
                edges {
                  node {
                    id
                    title
                    position
                    plist_events(first: 99999) @connection(key: "PipelinesContainer_plist_events") {
                      edges {
                        node {
                          id
                          position
                          event {
                            id
                            user_event {
                              booking_status
                              start_at
                              end_at
                              user_event_segments(first: 99999) {
                                edges {
                                  node {
                                    location
                                    room
                                  }
                                }
                              }
                              event {
                                id
                                title
                                start_at
                                end_at
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        ...SearchContainer_viewer
      }`
  }
);



// WEBPACK FOOTER //
// ./webpack/components/Event/Pipelines/PipelinesContainer.js